'use client';

import { ReactNode, useEffect } from 'react';
import { Provider } from 'react-redux';
import { store } from '../../store/store';
import { setCredentials, markHydrated } from '@/features/auth/authSlice';
import { usePathname } from 'next/navigation';

export default function StoreProvider({ children }: { children: ReactNode }) {
  const pathname = usePathname(); // 可選：路由變化時觸發同步

  // 1) 首次載入：從 localStorage hydrate
  useEffect(() => {
    try {
      const rawUser = localStorage.getItem('meInfo');
      const rawToken = localStorage.getItem('token');
      const rawRefresh = localStorage.getItem('refreshToken');

      const meInfo = rawUser ? JSON.parse(rawUser) : null;
      const token = rawToken ?? null;
      const refreshToken = rawRefresh ?? null;

      store.dispatch(setCredentials({ meInfo, token, refreshToken }));
    } catch {
      // 略過
    } finally {
      store.dispatch(markHydrated());
    }
  }, []);

  // 2) 訂閱：狀態改變就寫回 localStorage（或清掉）
  useEffect(() => {
    const unsubscribe = store.subscribe(() => {
      const s = store.getState().auth;
      if (!s.hydrated) return; // 避免尚未 hydrate 就寫入

      if (s.token) {
        localStorage.setItem('token', s.token);
      } else {
        localStorage.removeItem('token');
      }

      if (s.refreshToken) {
        localStorage.setItem('refreshToken', s.refreshToken);
      } else {
        localStorage.removeItem('refreshToken');
      }

      if (s.meInfo) {
        localStorage.setItem('meInfo', JSON.stringify(s.meInfo));
      } else {
        localStorage.removeItem('userInfo');
      }
    });
    return unsubscribe;
  }, [pathname]); // 可選：依路由變動觸發，讓登入/登出後頁面切換更即時

  return <Provider store={store}>{children}</Provider>;
}
